import React from "react";
import About from "./components/About/About";
import AboutSite from "./components/About/AboutSite/AboutSite";
import AboutScales from "./components/About/AboutScales/AboutScales";
import AboutTbot from "./components/About/AboutTelegram/AboutTbot";
import Administrator from "./components/Administrator/Administrator";
import Home from "./components/Home";
import LoginForm from "./components/LoginForm";
import Profile from "./components/Profile/Profile";
import Scales from "./components/Scales";
import UserCharts from "./components/UserChart/UserCharts";
import AdminCharts from "./components/Administrator/Instruments/AdminChart/AdminCharts";

const AppRoutes = [
    {
        index: true,
        element: <Home/>
    },
    {
        path: '/ws',
        element: <Home/>
    },
    {
        path: '/scales',
        element: <Scales/>
    },
    {
        path: '/login',
        element: <LoginForm/>
    },
    {
        path: '/scales/user-charts',
        element: <UserCharts/>
    },
    {
        path: '/administrator',
        element: <Administrator/>
    },
    {
        path: '/administrator/charts',
        element: <AdminCharts />
    },
    {
        path: '/profile',
        element: <Profile/>
    },
    {
        path: '/about',
        element: <About/>
    },
    {
        path: '/about/scales',
        element: <AboutScales/>
    },
    {
        path: '/about/site',
        element: <AboutSite/>
    },
    {
        path: '/about/tbot',
        element: <AboutTbot />
    }
];

export default AppRoutes;
